import { Link } from 'wouter';
import rosenblumLogo from '@assets/RLF_Hori_Lockup.jpg';

export default function Footer() {
  return (
    <footer className="bg-[#343A40] text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="mb-4">
              <img 
                src={rosenblumLogo} 
                alt="Rosenblum Law" 
                className="h-10 w-auto bg-white p-1 rounded"
                loading="lazy"
              />
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Rosenblum Law is a team of experienced attorneys who provide trusted estate planning services to help protect your family, your assets, and your legacy.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="https://www.rosenblumlaw.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">Home</a></li>
              <li><a href="https://www.rosenblumlaw.com/about" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">About Us</a></li>
              <li><a href="https://www.rosenblumlaw.com/practice-areas" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">Practice Areas</a></li>
              <li><a href="https://www.rosenblumlaw.com/contact" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">Contact</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-2">
              <li className="flex items-center">
                <i className="fas fa-envelope text-secondary mr-2"></i>
                <a href="mailto:info@rosenblumlaw.com" className="text-gray-400 hover:text-white transition">info@rosenblumlaw.com</a>
              </li>
              <li className="flex items-center">
                <i className="fas fa-phone text-secondary mr-2"></i>
                <a href="tel:+1888-815-3649" className="text-gray-400 hover:text-white transition">+1 (888) 815-3649</a>
              </li>
              <li className="flex items-start">
                <i className="fas fa-map-marker-alt text-secondary mr-2 mt-1"></i>
                <span className="text-gray-400">777 Passaic Ave Suite #460, Clifton, NJ 07012</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} Rosenblum Law. All rights reserved.
          </div>
          <div className="flex space-x-4 text-sm">
            <a href="https://www.rosenblumlaw.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">Privacy Policy</a>
            <a href="https://www.rosenblumlaw.com/terms-of-service" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">Terms of Service</a>
            <a href="https://www.rosenblumlaw.com/cookie-policy" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">Cookie Policy</a>
            <Link href="/admin" className="text-gray-500 hover:text-gray-400 transition text-xs">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
